import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TimelogSheet } from 'TimelogDataTypes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimelogSheetService {
  constructor(private http: HttpClient) {}

  getSheets(): Observable<TimelogSheet[]> {
    return this.http.get<TimelogSheet[]>('/api/TimelogSheets');
  }

  updateSheets(sheet: TimelogSheet): Observable<TimelogSheet> {
    return this.http.put<TimelogSheet>('/api/TimelogSheets', sheet);
  }

  deleteSheets(id: number): Observable<TimelogSheet> {
    return this.http.delete<TimelogSheet>('/api/TimelogSheets/' + id);
  }
}
